export const SUBJECTS = [
   { value: 'general', label: 'General Feedback' },
   { value: 'bug', label: 'Issue/Bug' },
   { value: 'feature_request', label: 'Feature Request' },
   { value: 'feature_improvement', label: 'Feature Improvement' },
   { value: 'suggestion', label: 'Suggestion' },
]